export var AfriexLedgerReasons;
(function (AfriexLedgerReasons) {
    AfriexLedgerReasons["INFLUENCER_PAYMENT"] = "INFLUENCER_PAYMENT";
    AfriexLedgerReasons["MISSING_DEPOSIT"] = "MISSING_DEPOSIT";
    AfriexLedgerReasons["REFERRAL_BONUS"] = "REFERRAL_BONUS";
    AfriexLedgerReasons["LOST_DISPUTE"] = "LOST_DISPUTE";
    AfriexLedgerReasons["STRIPE_REFUND"] = "STRIPE_REFUND";
    AfriexLedgerReasons["WRONG_CREDIT"] = "WRONG_CREDIT";
    AfriexLedgerReasons["OTHERS"] = "OTHERS";
    AfriexLedgerReasons["ADMIN_LEDGER_ACTION"] = "ADMIN_LEDGER_ACTION";
    // Funds a business's Fee wallet from a paid fee invoice. Distinct from
    // ADMIN_LEDGER_ACTION so invoice funding stays identifiable in the ledger.
    AfriexLedgerReasons["INVOICE_PAYMENT"] = "INVOICE_PAYMENT";
    AfriexLedgerReasons["BUSINESS_AFFILIATE_REWARD"] = "BUSINESS_AFFILIATE_REWARD";
    AfriexLedgerReasons["BUSINESS_AFFILIATE_CLAWBACK"] = "BUSINESS_AFFILIATE_CLAWBACK";
})(AfriexLedgerReasons || (AfriexLedgerReasons = {}));
//# sourceMappingURL=AfriexLedgerReasons.js.map